/**
 * @file: 顶板cube render 方法
 * @author: xiaolong.huang@dmall.com
 */

import * as UIToolkit from '../../UIToolkit/index';
import * as RoofRenderCore from './renderCore/index';
import { Watcher } from '../../observe/index';

export default function render(cube: FreeObjMap): void {
    UIToolkit.updateFreeLayerInShelfSize(cube.id);
    // UIToolkit.updateLayerHeight(cube);

    // 渲染顶板位置、大小
    new Watcher(() => {
        RoofRenderCore.renderPosition(cube);
    });

    // 渲染横杆文字模式，内置显示规则
    new Watcher(() => {
        RoofRenderCore.renderRoofTxtModel(cube);
    });

    // 渲染警告信息
    new Watcher(() => {
        UIToolkit.layerWarning(cube);
    });

    // 渲染状态切换
    RoofRenderCore.statusSwitch(cube);

    // 设置流动边框动画属性
    UIToolkit.setFlowBorderPropertiy(cube);
}
